module.exports = __webpack_public_path__ + "static/media/canalbolditalic.4b454cf9.woff2";